import { SVGProps, Ref, forwardRef } from 'react';

export const FolderHyperstarFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M12.204 6.9c3.272 0 4.214.927 3.63 3.678a8 8 0 0 1-1.169-1.354L13.5 7.477l-1.165 1.747a8.1 8.1 0 0 1-2.111 2.111L8.477 12.5l1.747 1.165c.5.334 1.01.784 1.449 1.27q-.58.064-1.273.065H5.6C2.206 15 .96 13.897.236 10.898-.49 7.9.4 6.9 3.795 6.9z"
                        fill="currentColor"
                    />
                    <path
                        d="M8.2 2.333h2.133c3.078 0 4.352.903 4.614 3.501a5 5 0 0 0-.305-.087c-.711-.182-1.535-.247-2.438-.247H3.796c-.902 0-1.726.065-2.437.247q-.18.045-.359.105v-.185C1 2.167 2.167 1 5.667 1h2z"
                        fill="currentColor"
                    />
                    <path
                        d="M13.5 10a9.5 9.5 0 0 0 2.5 2.5 9.5 9.5 0 0 0-2.5 2.5 9.5 9.5 0 0 0-2.5-2.5 9.5 9.5 0 0 0 2.5-2.5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
FolderHyperstarFilledSize16Glyph.displayName = 'FolderHyperstarFilledSize16Glyph';
